import { render, staticRenderFns } from "./cartridge-edit.vue?vue&type=template&id=5ff36c3a&"
import script from "./cartridge-edit.vue?vue&type=script&lang=js&"
export * from "./cartridge-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff36c3a')) {
      api.createRecord('5ff36c3a', component.options)
    } else {
      api.reload('5ff36c3a', component.options)
    }
    module.hot.accept("./cartridge-edit.vue?vue&type=template&id=5ff36c3a&", function () {
      api.rerender('5ff36c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/cartridge-list/cartridge-edit.vue"
export default component.exports